var exports = {
  "name": "NameStyle.module__name___ZTk0V0",
  "clip": "NameStyle.module__clip___ZTk0V0",
  "gradient": "NameStyle.module__gradient___ZTk0V0",
  "neon": "NameStyle.module__neon___ZTk0V0",
  "toon": "NameStyle.module__toon___ZTk0V0",
  "pop": "NameStyle.module__pop___ZTk0V0",
  "gummy": "NameStyle.module__gummy___ZTk0V0",
  "prism": "NameStyle.module__prism___ZTk0V0",
  "cfnFlow": "NameStyle.module__cfnFlow___ZTk0V0",
  "shimmer": "NameStyle.module__shimmer___ZTk0V0",
  "cfnShine": "NameStyle.module__cfnShine___ZTk0V0",
};

__webpack_require__.r(module.exports = exports);
